import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { spiceroad } from '..';

export interface UseDrawPreviewProps {
  previewData: any;
  isErrorPreview: Error | null;
  triggerPreview: any;
  mutation: UseMutationResult<any, Error, drawReq>;
}
export interface drawReq {
  apr: number;
  drawAmount: number;
  fundingMethod?: string;
  outstandingPrincipal: number;
}

export function useDrawPreview(locId: any): UseDrawPreviewProps {
  const mutation = useMutation({
    mutationFn: (arg: drawReq) =>
      spiceroad
        .post(`/v1/locs/${locId}/draw/preview`, arg)
        .then((res) => res.data),
    mutationKey: ['drawPreview', locId],
  });

  return {
    previewData: mutation.data,
    triggerPreview: mutation.mutateAsync,
    isErrorPreview: mutation.error,
    mutation,
  };
}

export default useDrawPreview;
